import { useState, useEffect } from 'react';
import ReactModal from 'react-modal';
import { modalConfig, ModalName } from './constants';

interface Props {
  modalName?: ModalName;
  unsetModal: () => void;
}

const SMALL_HEIGHT = 825;
const SMALL_WIDTH = 1377;

const Modal = ({ modalName, unsetModal }: Props): JSX.Element | null => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerHeight < SMALL_HEIGHT || window.innerWidth < SMALL_WIDTH);

  useEffect(() => {
    const handleResize = (): void => {
      setIsSmallScreen(window.innerHeight < SMALL_HEIGHT || window.innerWidth < SMALL_WIDTH);
    };

    window.addEventListener('resize', handleResize);
    return (): void => window.removeEventListener('resize', handleResize);
  }, []);

  let modalClasses = '';
  let CurrentModal = null;

  if (modalName && modalConfig[modalName]) {
    const config = modalConfig[modalName];
    CurrentModal = config.modal;
    modalClasses = config.classes;

    if (modalName === ModalName.MembershipDiscount && isSmallScreen) {
      modalClasses = 'rounded-md xs:w-full md:w-2/5 md:border-neutral-200 overflow-x-hidden overflow-y-auto relative top-0 mx-auto max-h-screen';
    }
  }

  return (
    <ReactModal
      isOpen={!!modalName}
      shouldCloseOnOverlayClick
      onRequestClose={unsetModal}
      className={modalClasses}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          zIndex: 1000,
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
          overflowY: 'auto',
        },
      }}
      closeTimeoutMS={400}
    >
      {CurrentModal ? <CurrentModal /> : null}
    </ReactModal>
  );
};

export default Modal;
